import React from 'react';
import { Fab } from '@material-ui/core';
import { CloudDownloadOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import API_REST from '../../api-rest-uruk';

const selectStepWithFiles = (steps = []) =>
  steps.filter((step) => step.files && step.files.length);

const selectStepSigned = (steps = []) =>
  steps.filter((step) => step.status === 'signed');

const donwloadFiles = (files) => {
  for (var i = 0; i < files.length; i++) {
    setTimeout(window.open(files[i]), 200 + i * 200);
  }
};

const parseFlow = (flow) => {
  if (typeof flow === 'string') {
    return JSON.parse(flow);
  }
  return flow;
};

function DownloadFilesStep ({ flow }) {
  const { t } = useTranslation();
  const flowParsed = parseFlow(flow);
  const { steps, flowId } = flowParsed;
  const stepsSigned = selectStepSigned(steps);
  const stepWithFiles = selectStepWithFiles(stepsSigned);
  const showButton = stepWithFiles.length <= 0;
  const handleClickDownloadFiles = async () => {
    const request = { flowId };
    const response = await API_REST.getPresignUrlFromS3BucketAttachments(request);
    donwloadFiles(response.data.preSignUrls);
  };

  if (showButton) return null;

  return (
    <Fab
      color='secondary'
      aria-label={t('processDetail:downloadAttachment')}
      variant={'extended'}
      onClick={handleClickDownloadFiles}
    >
      <CloudDownloadOutlined style={{ marginRight: '8px' }} />
      {t('processDetail:downloadAttachment')}
    </Fab>
  );
}

export default DownloadFilesStep;
